import { useEffect } from "react";
import type { MouseEvent } from "react";

/**
 * Adds "Escape to close" behavior and returns an onClick handler for the
 * overlay/backdrop element that closes the modal when clicking outside its
 * content (i.e. directly on the overlay, not a child of it).
 */
export function useModalDismiss(open: boolean, onClose: () => void) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  const onOverlayClick = (e: MouseEvent<HTMLElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  return { onOverlayClick };
}
